<template>
  <b-modal
    id="'justificativaProposta'"
    :ref="'justificativaProposta'"
    hide-footer
    hide-header
    centered
    size="md"
    no-close-on-backdrop
  >
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12">
            <b-button
              variant="none"
              class="close "
              @click="cancelar()"
            >
              <span aria-hidden="true">&times;</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            style="text-align:start;"
          >
            <h4 style="padding-left: 15px;">
              {{ propostaRecusada ? 'Informe o motivo de não aprovar a proposta!' : 'Confirme a aprovação da proposta' }}
            </h4>
            <fieldset
              v-if="!propostaRecusada"
              class="font-weight-bold text-muted small"
              style="padding-left: 15px;"
            >
              Ao realizar essa ação você aprova a proposta e uma notificação será enviada ao gerente para realizar
              a continuidade do processo
            </fieldset>
            <div
              class="mt-1 px-1"
              style="flex-grow:1"
            >
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    :label="propostaRecusada ? '' : 'Adicione uma observação'"
                    style="text-align: start;"
                  >
                    <b-textarea
                      v-model="mensagem"
                      :placeholder="propostaRecusada ? 'Justifique (obrigatório)' : 'Observação (opcional)'"
                      rows="3"
                      max-rows="6"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-1">
                <b-col cols="6">
                  <b-btn
                    variant="danger"
                    class="w-100"
                    @click="cancelar()"
                  >Cancelar</b-btn>
                </b-col>
                <b-col
                  v-if="propostaRecusada"
                  cols="6"
                >
                  <b-btn
                    variant="success"
                    class="w-100"
                    @click="naoAprovar()"
                  >Recusar</b-btn>
                </b-col>
                <b-col
                  v-else
                  cols="6"
                >
                  <b-btn
                    variant="success"
                    class="w-100"
                    @click="aprovar()"
                  >Aprovar</b-btn>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'JustificativaProposta',
  props: {
    propostaRecusada: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mensagem: '',
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.justificativaProposta.show()
    })
  },
  methods: {
    cancelar() {
      this.$refs.justificativaProposta.hide()
      this.$emit('cancelar')
    },
    naoAprovar() {
      const justSemEspaco = this.mensagem.replace(/\s+/g, '')
      if (!this.mensagem || justSemEspaco.length < 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: !this.mensagem ? 'A justificativa de não aprovar é obrigatória.' : 'O motivo deve ter no mínimo 10 caracteres!',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } else {
        this.$refs.justificativaProposta.hide()
        this.$emit('hidden', this.mensagem)
      }
    },
    aprovar() {
      this.$refs.justificativaProposta.hide()
      this.$emit('hidden', this.mensagem)
    },
  },
}
</script>
